// Expert API for Admin

import { apiClient } from '@/core/api/client';
import type { 
  ExpertsApiResponse, 
  ExpertDossiersApiResponse,
  ExpertStatsApiResponse
} from '../types/expert.types';

export const expertAPI = {
  /**
   * Get all experts with their workload statistics
   */
  async getAllExperts(): Promise<ExpertsApiResponse> {
    try {
      const response = await apiClient.get('/api/admin/experts');
      return response as ExpertsApiResponse;
    } catch (error) {
      console.error('Error fetching experts:', error);
      throw error;
    }
  },

  /**
   * Get all dossiers for a specific expert
   */
  async getExpertDossiers(expertFmName: string): Promise<ExpertDossiersApiResponse> {
    try {
      const response = await apiClient.get(
        `/api/admin/experts/${encodeURIComponent(expertFmName)}/dossiers`
      );
      return response as ExpertDossiersApiResponse;
    } catch (error) {
      console.error(`Error fetching dossiers for expert ${expertFmName}:`, error);
      throw error;
    }
  },

  /**
   * Get detailed statistics for a specific expert
   */
  async getExpertStats(expertFmName: string): Promise<ExpertStatsApiResponse> {
    try {
      const response = await apiClient.get(
        `/api/admin/experts/${encodeURIComponent(expertFmName)}/stats`
      );
      return response as ExpertStatsApiResponse;
    } catch (error) {
      console.error(`Error fetching stats for expert ${expertFmName}:`, error);
      throw error;
    }
  }
};